<template>
  <div>
    <template v-if="tableOfContents">
      <div v-for="(item, key) in descriptionsData" :key="'tocPos-' + key">
        <h3 v-html="item.title"></h3>
        <div v-html="item.toc"></div>
      </div>
    </template>
    <article v-for="(item, key) in descriptionsData" :key="key">
      <h3 v-if="item.title.length" v-html="item.title"></h3>
      <p v-html="htmlDecode(item.content)"></p>
    </article>
  </div>
</template>

<script>
export default {
  props: {
    descriptionsData: Array,
    tableOfContents: Boolean
  },
  data: () => ({}),
  methods: {
  	htmlDecode(input) {
		try {
  			let doc = new DOMParser().parseFromString(input, "text/html");
  			return doc.documentElement.textContent;
		} catch (e) {
			return input;
		}
	}
  }
};
</script>
